export default __webpack_public_path__ + "media/builders/preview-b8e7ff39.png";